module.exports = __webpack_public_path__ + "logo-incluir-da-certo.png?0ab8b0e31b53232f662a7308423a9199";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-incluir-da-certo.png
// module id = 242
// module chunks = 0